<template>
  <div class="content">
    <div class="lald-case__block-head-child d-md-none mb-8">
      <div class="lald-case__block-head-child-info">Денис (5 лет)</div>
      <div class="lald-case__block-head-child-avatar">
        <img
          :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy-avatar.png 2x`"
        />
      </div>
    </div>
    <div class="lald-case__block">
      <div class="lald-case__block-head">
        <div class="lald-case__block-head-title">
          <div v-if="variant == 1">Неалкогольная жировая болезнь печени</div>
          <div v-if="variant == 2">Семейная гиперхолестеринемия</div>
          <div v-if="variant == 3">Дефицит лизосомной кислой липазы</div>
        </div>
        <div class="lald-case__block-head-child d-none d-md-flex">
          <div class="lald-case__block-head-child-info">Денис (5 лет)</div>
          <div class="lald-case__block-head-child-avatar">
            <img
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy-avatar.png 2x`"
            />
          </div>
        </div>
      </div>
      <div class="lald-case__block-body">
        <div class="lald-case__block-body-row">
          <div class="lald-case__block-body-img d-none d-xl-block">
            <img
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy.png 2x`"
            />
          </div>
          <div class="lald-case__block-body-content">
            <div v-if="variant == 1">
              <div class="lald-case__block-body-content-status">
                <svg
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="29" height="29" rx="14.5" fill="#CF1517" />
                  <path
                    d="M11.6956 10.6839L14.5449 13.5331L17.3794 10.6987C17.442 10.632 17.5174 10.5787 17.6012 10.5419C17.6849 10.5052 17.7751 10.4857 17.8666 10.4846C18.0624 10.4846 18.2501 10.5624 18.3885 10.7008C18.527 10.8392 18.6047 11.027 18.6047 11.2227C18.6065 11.3132 18.5897 11.4031 18.5554 11.4869C18.5211 11.5707 18.4701 11.6466 18.4054 11.7099L15.534 14.5443L18.4054 17.4156C18.5271 17.5347 18.5984 17.6958 18.6047 17.8659C18.6047 18.0617 18.527 18.2494 18.3885 18.3878C18.2501 18.5263 18.0624 18.604 17.8666 18.604C17.7725 18.6079 17.6787 18.5922 17.591 18.5579C17.5033 18.5236 17.4237 18.4715 17.3573 18.4047L14.5449 15.5556L11.7029 18.3974C11.6406 18.4618 11.5661 18.5132 11.4837 18.5487C11.4014 18.5842 11.3128 18.603 11.2231 18.604C11.0274 18.604 10.8396 18.5263 10.7012 18.3878C10.5628 18.2494 10.485 18.0617 10.485 17.8659C10.4833 17.7754 10.5001 17.6855 10.5343 17.6017C10.5686 17.518 10.6196 17.4421 10.6843 17.3787L13.5557 14.5443L10.6843 11.673C10.5626 11.554 10.4913 11.3928 10.485 11.2227C10.485 11.027 10.5628 10.8392 10.7012 10.7008C10.8396 10.5624 11.0274 10.4846 11.2231 10.4846C11.4003 10.4868 11.5701 10.5584 11.6956 10.6839Z"
                    fill="white"
                  />
                </svg>
                <span style="color: #cf1517">Неверный диагноз</span>
              </div>
              <div class="lald-case__block-body-img d-xl-none mb-4">
                <img
                  :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy.png 2x`"
                />
              </div>
              <p class="default-text mb-2">
                К сожалению, диагноз неверный.
                <br />
                Гепатомегалия и повышение активности трансаминаз в сыворотке
                крови могут быть расценены как проявление болезней печени, в
                частности - неалкогольной жировой болезни печени. В данном
                случае у пациента отмечается еще и дислипидемия.
              </p>
              <p class="default-text mb-2">
                Важно учитывать ДЛКЛ при дифференциальной диагностике пациентов
                с дислипидемией в сочетании с признаками поражения печени.
              </p>
              <ul class="mb-4">
                <li>
                  Важно исключить ДЛКЛ при обследовании детей и взрослых на
                  НАЖБП.
                </li>
                <li>
                  Повышенный уровень АЛТ поможет дифференцировать ДЛКЛ от
                  наследственных дислипидемий.
                </li>
              </ul>
              <hr />
              <p class="mt-4 mb-4 default-text">
                Мы подготовили удобную памятку с критериями диагностики ДЛКЛ.
              </p>
              <div class="lald-case__block-body-content-buttons">
                <a
                  class="button button_orange-gradient"
                  :href="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/1.pdf`"
                  target="_blank"
                >
                  Скачать памятку
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 15L3.75 8.75L5.5 6.9375L8.75 10.1875V0H11.25V10.1875L14.5 6.9375L16.25 8.75L10 15ZM2.5 20C1.8125 20 1.22417 19.7554 0.735 19.2662C0.245833 18.7771 0.000833333 18.1883 0 17.5V13.75H2.5V17.5H17.5V13.75H20V17.5C20 18.1875 19.7554 18.7762 19.2663 19.2662C18.7771 19.7562 18.1883 20.0008 17.5 20H2.5Z"
                      fill="white"
                    />
                  </svg>
                </a>
                <div class="button button_white" @click="$emit('repeat')">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.35921 7.80803L7.95321 7.32003C8.07882 7.28162 8.21077 7.26832 8.34151 7.2809C8.47226 7.29348 8.59925 7.33169 8.71523 7.39335C8.83121 7.45501 8.93391 7.53891 9.01747 7.64026C9.10102 7.74161 9.1638 7.85842 9.20221 7.98403C9.24062 8.10964 9.25392 8.24158 9.24134 8.37233C9.22876 8.50308 9.19055 8.63007 9.12889 8.74605C9.06723 8.86203 8.98333 8.96473 8.88198 9.04829C8.78064 9.13184 8.66382 9.19462 8.53821 9.23303L4.71321 10.403C4.58754 10.4415 4.45552 10.4547 4.32472 10.4421C4.19391 10.4295 4.06688 10.3912 3.95088 10.3294C3.83488 10.2676 3.73219 10.1836 3.64869 10.0822C3.56518 9.98068 3.50249 9.86375 3.46421 9.73803L2.29421 5.91303C2.2558 5.78742 2.24251 5.65547 2.25509 5.52473C2.26767 5.39398 2.30588 5.26699 2.36754 5.15101C2.42919 5.03503 2.51309 4.93233 2.61444 4.84877C2.71579 4.76522 2.8326 4.70244 2.95821 4.66403C3.21189 4.58645 3.486 4.61283 3.72023 4.73735C3.95446 4.86188 4.12964 5.07435 4.20721 5.32803L4.64721 6.76903C7.05521 3.06003 11.8322 1.46503 16.0732 3.20303C17.3416 3.72283 18.4806 4.51429 19.4101 5.52172C20.3396 6.52914 21.037 7.72804 21.4532 9.03403C21.4959 9.15983 21.5131 9.29288 21.5038 9.4254C21.4944 9.55792 21.4588 9.68725 21.399 9.80585C21.3391 9.92444 21.2562 10.0299 21.1551 10.1161C21.0541 10.2023 20.9368 10.2675 20.8103 10.3079C20.6837 10.3483 20.5504 10.3631 20.418 10.3514C20.2857 10.3397 20.157 10.3017 20.0396 10.2397C19.9221 10.1777 19.8181 10.0929 19.7337 9.99032C19.6494 9.8877 19.5863 9.7693 19.5482 9.64203C19.1257 8.3154 18.3367 7.13531 17.2721 6.23803C16.2075 5.34074 14.9109 4.76285 13.5319 4.57108C12.1529 4.37931 10.7478 4.58147 9.47876 5.15424C8.20976 5.72701 7.12763 6.64701 6.35921 7.80803ZM18.6862 16.003L16.9112 16.446C16.7827 16.4813 16.6484 16.4905 16.5163 16.4731C16.3842 16.4557 16.2568 16.4121 16.1418 16.3448C16.0268 16.2775 15.9263 16.1879 15.8464 16.0812C15.7665 15.9746 15.7087 15.853 15.6765 15.7237C15.6442 15.5944 15.6381 15.4599 15.6586 15.3282C15.679 15.1966 15.7256 15.0703 15.7955 14.9568C15.8655 14.8434 15.9574 14.7451 16.0659 14.6677C16.1743 14.5902 16.2972 14.5353 16.4272 14.506L20.0702 13.597C20.2601 13.5069 20.4735 13.4789 20.6802 13.517C20.8794 13.5432 21.066 13.6288 21.2158 13.7626C21.3656 13.8963 21.4717 14.0721 21.5202 14.267L22.4882 18.147C22.5456 18.4019 22.5009 18.669 22.3638 18.8914C22.2268 19.1137 22.0081 19.2736 21.7547 19.3368C21.5012 19.4001 21.2331 19.3616 21.0077 19.2297C20.7822 19.0978 20.6173 18.8829 20.5482 18.631L20.2182 17.309C19.2554 18.6946 17.9367 19.7948 16.401 20.4939C14.8654 21.1929 13.1696 21.4648 11.4924 21.2809C9.81516 21.097 8.21858 20.4642 6.87082 19.4492C5.52306 18.4341 4.47402 17.0743 3.83421 15.513L3.57421 14.879C3.52444 14.7575 3.4991 14.6273 3.49962 14.496C3.50015 14.3647 3.52654 14.2347 3.57729 14.1136C3.62804 13.9925 3.70215 13.8825 3.79539 13.79C3.88863 13.6975 3.99917 13.6243 4.12071 13.5745C4.36617 13.474 4.64151 13.4751 4.88615 13.5776C5.00728 13.6284 5.11723 13.7025 5.20973 13.7957C5.30222 13.8889 5.37544 13.9995 5.42521 14.121L5.68521 14.754C6.19496 15.9979 7.03471 17.0789 8.11383 17.8804C9.19295 18.6819 10.4705 19.1735 11.8085 19.3022C13.1466 19.4308 14.4944 19.1916 15.7064 18.6104C16.9185 18.0291 17.9488 17.1269 18.6862 16.003Z"
                      fill="#8B8E8E"
                    />
                  </svg>
                  Попробовать снова
                </div>
              </div>
            </div>
            <div v-if="variant == 2">
              <div class="lald-case__block-body-content-status">
                <svg
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="29" height="29" rx="14.5" fill="#CF1517" />
                  <path
                    d="M11.6956 10.6839L14.5449 13.5331L17.3794 10.6987C17.442 10.632 17.5174 10.5787 17.6012 10.5419C17.6849 10.5052 17.7751 10.4857 17.8666 10.4846C18.0624 10.4846 18.2501 10.5624 18.3885 10.7008C18.527 10.8392 18.6047 11.027 18.6047 11.2227C18.6065 11.3132 18.5897 11.4031 18.5554 11.4869C18.5211 11.5707 18.4701 11.6466 18.4054 11.7099L15.534 14.5443L18.4054 17.4156C18.5271 17.5347 18.5984 17.6958 18.6047 17.8659C18.6047 18.0617 18.527 18.2494 18.3885 18.3878C18.2501 18.5263 18.0624 18.604 17.8666 18.604C17.7725 18.6079 17.6787 18.5922 17.591 18.5579C17.5033 18.5236 17.4237 18.4715 17.3573 18.4047L14.5449 15.5556L11.7029 18.3974C11.6406 18.4618 11.5661 18.5132 11.4837 18.5487C11.4014 18.5842 11.3128 18.603 11.2231 18.604C11.0274 18.604 10.8396 18.5263 10.7012 18.3878C10.5628 18.2494 10.485 18.0617 10.485 17.8659C10.4833 17.7754 10.5001 17.6855 10.5343 17.6017C10.5686 17.518 10.6196 17.4421 10.6843 17.3787L13.5557 14.5443L10.6843 11.673C10.5626 11.554 10.4913 11.3928 10.485 11.2227C10.485 11.027 10.5628 10.8392 10.7012 10.7008C10.8396 10.5624 11.0274 10.4846 11.2231 10.4846C11.4003 10.4868 11.5701 10.5584 11.6956 10.6839Z"
                    fill="white"
                  />
                </svg>
                <span style="color: #cf1517">Неверный диагноз</span>
              </div>
              <div class="lald-case__block-body-img d-xl-none mb-4">
                <img
                  :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy.png 2x`"
                />
              </div>
              <p class="default-text mb-2">
                К сожалению, диагноз неверный.
                <br />
                Дислипидемия в данном случае может быть расценена как проявление
                болезней, связанных с нарушениями липидного обмена. Повышение
                общего холестерина, холестерина ЛПНП и снижение холестерина ЛПВП
                может говорить о семейной гиперхолестеринемии.
                <br />Вместе с тем у пациента отмечаются и нехарактерные
                симптомы, такие как повышенный уровень АЛТ и гематомегалия.
              </p>
              <p class="default-text mb-2">
                Важно учитывать ДЛКЛ при дифференциальной диагностике пациентов
                с дислипидемией в сочетании с признаками поражения печени.
              </p>
              <ul class="mb-4">
                <li>
                  Важно исключить ДЛКЛ при обследовании детей и взрослых с
                  нарушениями липидного обмена.
                </li>
                <li>
                  Повышенный уровень АЛТ поможет дифференцировать ДЛКЛ от
                  наследственных дислипидемий.
                </li>
              </ul>
              <hr />
              <p class="mt-4 mb-4 default-text">
                Мы подготовили удобную памятку с критериями диагностики ДЛКЛ.
              </p>
              <div class="lald-case__block-body-content-buttons">
                <a
                  class="button button_orange-gradient"
                  :href="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/2.pdf`"
                  target="_blank"
                >
                  Скачать памятку
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 15L3.75 8.75L5.5 6.9375L8.75 10.1875V0H11.25V10.1875L14.5 6.9375L16.25 8.75L10 15ZM2.5 20C1.8125 20 1.22417 19.7554 0.735 19.2662C0.245833 18.7771 0.000833333 18.1883 0 17.5V13.75H2.5V17.5H17.5V13.75H20V17.5C20 18.1875 19.7554 18.7762 19.2663 19.2662C18.7771 19.7562 18.1883 20.0008 17.5 20H2.5Z"
                      fill="white"
                    />
                  </svg>
                </a>
                <div class="button button_white" @click="$emit('repeat')">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.35921 7.80803L7.95321 7.32003C8.07882 7.28162 8.21077 7.26832 8.34151 7.2809C8.47226 7.29348 8.59925 7.33169 8.71523 7.39335C8.83121 7.45501 8.93391 7.53891 9.01747 7.64026C9.10102 7.74161 9.1638 7.85842 9.20221 7.98403C9.24062 8.10964 9.25392 8.24158 9.24134 8.37233C9.22876 8.50308 9.19055 8.63007 9.12889 8.74605C9.06723 8.86203 8.98333 8.96473 8.88198 9.04829C8.78064 9.13184 8.66382 9.19462 8.53821 9.23303L4.71321 10.403C4.58754 10.4415 4.45552 10.4547 4.32472 10.4421C4.19391 10.4295 4.06688 10.3912 3.95088 10.3294C3.83488 10.2676 3.73219 10.1836 3.64869 10.0822C3.56518 9.98068 3.50249 9.86375 3.46421 9.73803L2.29421 5.91303C2.2558 5.78742 2.24251 5.65547 2.25509 5.52473C2.26767 5.39398 2.30588 5.26699 2.36754 5.15101C2.42919 5.03503 2.51309 4.93233 2.61444 4.84877C2.71579 4.76522 2.8326 4.70244 2.95821 4.66403C3.21189 4.58645 3.486 4.61283 3.72023 4.73735C3.95446 4.86188 4.12964 5.07435 4.20721 5.32803L4.64721 6.76903C7.05521 3.06003 11.8322 1.46503 16.0732 3.20303C17.3416 3.72283 18.4806 4.51429 19.4101 5.52172C20.3396 6.52914 21.037 7.72804 21.4532 9.03403C21.4959 9.15983 21.5131 9.29288 21.5038 9.4254C21.4944 9.55792 21.4588 9.68725 21.399 9.80585C21.3391 9.92444 21.2562 10.0299 21.1551 10.1161C21.0541 10.2023 20.9368 10.2675 20.8103 10.3079C20.6837 10.3483 20.5504 10.3631 20.418 10.3514C20.2857 10.3397 20.157 10.3017 20.0396 10.2397C19.9221 10.1777 19.8181 10.0929 19.7337 9.99032C19.6494 9.8877 19.5863 9.7693 19.5482 9.64203C19.1257 8.3154 18.3367 7.13531 17.2721 6.23803C16.2075 5.34074 14.9109 4.76285 13.5319 4.57108C12.1529 4.37931 10.7478 4.58147 9.47876 5.15424C8.20976 5.72701 7.12763 6.64701 6.35921 7.80803ZM18.6862 16.003L16.9112 16.446C16.7827 16.4813 16.6484 16.4905 16.5163 16.4731C16.3842 16.4557 16.2568 16.4121 16.1418 16.3448C16.0268 16.2775 15.9263 16.1879 15.8464 16.0812C15.7665 15.9746 15.7087 15.853 15.6765 15.7237C15.6442 15.5944 15.6381 15.4599 15.6586 15.3282C15.679 15.1966 15.7256 15.0703 15.7955 14.9568C15.8655 14.8434 15.9574 14.7451 16.0659 14.6677C16.1743 14.5902 16.2972 14.5353 16.4272 14.506L20.0702 13.597C20.2601 13.5069 20.4735 13.4789 20.6802 13.517C20.8794 13.5432 21.066 13.6288 21.2158 13.7626C21.3656 13.8963 21.4717 14.0721 21.5202 14.267L22.4882 18.147C22.5456 18.4019 22.5009 18.669 22.3638 18.8914C22.2268 19.1137 22.0081 19.2736 21.7547 19.3368C21.5012 19.4001 21.2331 19.3616 21.0077 19.2297C20.7822 19.0978 20.6173 18.8829 20.5482 18.631L20.2182 17.309C19.2554 18.6946 17.9367 19.7948 16.401 20.4939C14.8654 21.1929 13.1696 21.4648 11.4924 21.2809C9.81516 21.097 8.21858 20.4642 6.87082 19.4492C5.52306 18.4341 4.47402 17.0743 3.83421 15.513L3.57421 14.879C3.52444 14.7575 3.4991 14.6273 3.49962 14.496C3.50015 14.3647 3.52654 14.2347 3.57729 14.1136C3.62804 13.9925 3.70215 13.8825 3.79539 13.79C3.88863 13.6975 3.99917 13.6243 4.12071 13.5745C4.36617 13.474 4.64151 13.4751 4.88615 13.5776C5.00728 13.6284 5.11723 13.7025 5.20973 13.7957C5.30222 13.8889 5.37544 13.9995 5.42521 14.121L5.68521 14.754C6.19496 15.9979 7.03471 17.0789 8.11383 17.8804C9.19295 18.6819 10.4705 19.1735 11.8085 19.3022C13.1466 19.4308 14.4944 19.1916 15.7064 18.6104C16.9185 18.0291 17.9488 17.1269 18.6862 16.003Z"
                      fill="#8B8E8E"
                    />
                  </svg>
                  Попробовать снова
                </div>
              </div>
            </div>
            <div v-if="variant == 3">
              <div class="lald-case__block-body-content-status">
                <svg
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="29" height="29" rx="14.5" fill="#15B842" />
                  <path
                    d="M20.5 10L12.1 20L8.5 16.25"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <span style="color: #15b842">Диагноз верный</span>
              </div>
              <div class="lald-case__block-body-img d-xl-none mb-4">
                <img
                  :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy.png 2x`"
                />
              </div>

              <p class="default-text mb-2">
                Важно учитывать ДЛКЛ при дифференциальной диагностике пациентов
                с дислипидемией в сочетании с признаками поражения печени,
              </p>
              <ul class="mb-4">
                <li>
                  Важно исключить ДЛКЛ при обследовании детей и взрослых на
                  НАЖБП.
                </li>
                <li>
                  Повышенный уровень АЛТ поможет дифференцировать ДЛКП от
                  наследственных дислипидемий.
                </li>
              </ul>
              <hr />
              <p class="mt-4 mb-4 default-text">
                Мы подготовили удобную памятку с критериями диагностики ДЛКЛ.
              </p>
              <div class="lald-case__block-body-content-buttons">
                <a
                  class="button button_orange-gradient"
                  :href="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/1.pdf`"
                  target="_blank"
                >
                  Скачать памятку
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 15L3.75 8.75L5.5 6.9375L8.75 10.1875V0H11.25V10.1875L14.5 6.9375L16.25 8.75L10 15ZM2.5 20C1.8125 20 1.22417 19.7554 0.735 19.2662C0.245833 18.7771 0.000833333 18.1883 0 17.5V13.75H2.5V17.5H17.5V13.75H20V17.5C20 18.1875 19.7554 18.7762 19.2663 19.2662C18.7771 19.7562 18.1883 20.0008 17.5 20H2.5Z"
                      fill="white"
                    />
                  </svg>
                </a>
                <div class="button button_white" @click="$emit('repeat')">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.35921 7.80803L7.95321 7.32003C8.07882 7.28162 8.21077 7.26832 8.34151 7.2809C8.47226 7.29348 8.59925 7.33169 8.71523 7.39335C8.83121 7.45501 8.93391 7.53891 9.01747 7.64026C9.10102 7.74161 9.1638 7.85842 9.20221 7.98403C9.24062 8.10964 9.25392 8.24158 9.24134 8.37233C9.22876 8.50308 9.19055 8.63007 9.12889 8.74605C9.06723 8.86203 8.98333 8.96473 8.88198 9.04829C8.78064 9.13184 8.66382 9.19462 8.53821 9.23303L4.71321 10.403C4.58754 10.4415 4.45552 10.4547 4.32472 10.4421C4.19391 10.4295 4.06688 10.3912 3.95088 10.3294C3.83488 10.2676 3.73219 10.1836 3.64869 10.0822C3.56518 9.98068 3.50249 9.86375 3.46421 9.73803L2.29421 5.91303C2.2558 5.78742 2.24251 5.65547 2.25509 5.52473C2.26767 5.39398 2.30588 5.26699 2.36754 5.15101C2.42919 5.03503 2.51309 4.93233 2.61444 4.84877C2.71579 4.76522 2.8326 4.70244 2.95821 4.66403C3.21189 4.58645 3.486 4.61283 3.72023 4.73735C3.95446 4.86188 4.12964 5.07435 4.20721 5.32803L4.64721 6.76903C7.05521 3.06003 11.8322 1.46503 16.0732 3.20303C17.3416 3.72283 18.4806 4.51429 19.4101 5.52172C20.3396 6.52914 21.037 7.72804 21.4532 9.03403C21.4959 9.15983 21.5131 9.29288 21.5038 9.4254C21.4944 9.55792 21.4588 9.68725 21.399 9.80585C21.3391 9.92444 21.2562 10.0299 21.1551 10.1161C21.0541 10.2023 20.9368 10.2675 20.8103 10.3079C20.6837 10.3483 20.5504 10.3631 20.418 10.3514C20.2857 10.3397 20.157 10.3017 20.0396 10.2397C19.9221 10.1777 19.8181 10.0929 19.7337 9.99032C19.6494 9.8877 19.5863 9.7693 19.5482 9.64203C19.1257 8.3154 18.3367 7.13531 17.2721 6.23803C16.2075 5.34074 14.9109 4.76285 13.5319 4.57108C12.1529 4.37931 10.7478 4.58147 9.47876 5.15424C8.20976 5.72701 7.12763 6.64701 6.35921 7.80803ZM18.6862 16.003L16.9112 16.446C16.7827 16.4813 16.6484 16.4905 16.5163 16.4731C16.3842 16.4557 16.2568 16.4121 16.1418 16.3448C16.0268 16.2775 15.9263 16.1879 15.8464 16.0812C15.7665 15.9746 15.7087 15.853 15.6765 15.7237C15.6442 15.5944 15.6381 15.4599 15.6586 15.3282C15.679 15.1966 15.7256 15.0703 15.7955 14.9568C15.8655 14.8434 15.9574 14.7451 16.0659 14.6677C16.1743 14.5902 16.2972 14.5353 16.4272 14.506L20.0702 13.597C20.2601 13.5069 20.4735 13.4789 20.6802 13.517C20.8794 13.5432 21.066 13.6288 21.2158 13.7626C21.3656 13.8963 21.4717 14.0721 21.5202 14.267L22.4882 18.147C22.5456 18.4019 22.5009 18.669 22.3638 18.8914C22.2268 19.1137 22.0081 19.2736 21.7547 19.3368C21.5012 19.4001 21.2331 19.3616 21.0077 19.2297C20.7822 19.0978 20.6173 18.8829 20.5482 18.631L20.2182 17.309C19.2554 18.6946 17.9367 19.7948 16.401 20.4939C14.8654 21.1929 13.1696 21.4648 11.4924 21.2809C9.81516 21.097 8.21858 20.4642 6.87082 19.4492C5.52306 18.4341 4.47402 17.0743 3.83421 15.513L3.57421 14.879C3.52444 14.7575 3.4991 14.6273 3.49962 14.496C3.50015 14.3647 3.52654 14.2347 3.57729 14.1136C3.62804 13.9925 3.70215 13.8825 3.79539 13.79C3.88863 13.6975 3.99917 13.6243 4.12071 13.5745C4.36617 13.474 4.64151 13.4751 4.88615 13.5776C5.00728 13.6284 5.11723 13.7025 5.20973 13.7957C5.30222 13.8889 5.37544 13.9995 5.42521 14.121L5.68521 14.754C6.19496 15.9979 7.03471 17.0789 8.11383 17.8804C9.19295 18.6819 10.4705 19.1735 11.8085 19.3022C13.1466 19.4308 14.4944 19.1916 15.7064 18.6104C16.9185 18.0291 17.9488 17.1269 18.6862 16.003Z"
                      fill="#8B8E8E"
                    />
                  </svg>
                  Попробовать снова
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lald-case__diagnostic">
      <div class="lald-case__diagnostic-title">Постановка диагноза</div>
      <div class="lald-case__diagnostic-subtitle">
        Почему важно учитывать ДЛКЛ при дифференциальной диагностике заболеваний
        печени и нарушений липидного обмена?
      </div>
      <p class="default-text mb-4">
        <b>Дефицит лизосомной кислой липазы (ДЛКЛ)</b> — редкое, но клинически
        значимое заболевание. Часто заболевание протекает бессимптомно,
        скрывается «под масками» других, более распространенных заболеваний, а
        лабораторные и инструментальные изменения* могут ошибочно расцениваться
        как проявления НАЖБП или семейной гиперхолестеринемии<sup>1</sup>.
        <br />
        «Золотым стандартом» диагностики ДЛКЛ является определение активности
        лизосомной кислой липазы (ЛКЛ) в сухих пятнах крови<sup>1,4</sup>. При
        выявлении снижения активности фермента ЛКЛ рекомендуется проведение
        молекулярно-генетического исследования гена
        <i style="font-style: italic">LIPA</i><sup>#1,5,6</sup>.
        <br />
        <br />
        Своевременное выявление ДЛКЛ имеет ключевое значение: раннее начало
        патогенетической терапии предотвращает развитие фиброза и цирроза печени
        и улучшает прогноз и качество жизни пациента.<sup>1</sup>
      </p>
      <img
        :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/table.jpg 2x`"
        :data-coolbox="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/table.jpg`"
      />
    </div>
    <div class="lald-case__materials">
      <div class="lald-case__materials-title">Полезные материалы</div>
      <div class="lald-case__materials-row">
        <a
          href="https://az-most.ru/therapeutic-areas/rare-diseases/dlkl"
          target="_blank"
          class="lald-case__materials-item"
        >
          <div class="lald-case__materials-item-img">
            <img
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/material1.jpg 2x`"
            />
          </div>
          <div class="lald-case__materials-item-title">
            Подробнее о заболевании ДЛКЛ
          </div>
          <div class="lald-case__materials-item-button button">Читать</div>
        </a>
        <a
          href="https://az-most.ru/mspk"
          target="_blank"
          class="lald-case__materials-item"
        >
          <div class="lald-case__materials-item-img">
            <img
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/material2.jpg 2x`"
            />
          </div>
          <div class="lald-case__materials-item-title">
            Подробнее о программе диогностике ДЛКЛ
          </div>
          <div class="lald-case__materials-item-button button">Читать</div>
        </a>
      </div>
    </div>
    <div class="lald-case__dropdown mb-8 mt-15">
      <input type="checkbox" id="lald-case__dropdown1" />
      <label for="lald-case__dropdown1" class="lald-case__dropdown-head">
        <div class="lald-case__dropdown-head-title">Примечания</div>
        <div class="lald-case__dropdown-arrow">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.25 8.25L12.75 15.75L5.25 8.25"
              stroke="#3C4242"
              stroke-width="1.5"
              stroke-linecap="square"
            />
          </svg>
        </div>
      </label>
      <div class="lald-case__dropdown-body">
        <p class="default-text">
          <b>Примечание:</b>
          <br />
          <br />
          * повышение АЛТ, гепатомегалия<sup>1</sup>.
          <br /># для подтверждения диагноза, уточнения типа мутации и оценки
          необходимости проведения семейной диагностики<sup>1,5,6</sup>.
          <br />
          <br />
          <b>Сокрашения</b>
          <br />
          <br />
          АЛТ — аланинаминотрансфераза
          <br />АСТ — аспартатаминотрансфераза <br />ДЛКЛ — дефицит лизосомной
          кислой липазы <br />ЖКТ — желудочно-кишечный тракт <br />ЛКЛ —
          лизосомная кислая липаза <br />ХС ЛПВП — холестерин липопротеинов
          высокой плотности <br />ХС ЛПНП — холестерин липопротеинов низкой
          плотности <br />НАЖБП — неалкогольная жировая болезнь печени <br />ХС
          — холестерин <br />ОХС - общий холестерин
        </p>
      </div>
    </div>
    <div class="lald-case__dropdown mb-8">
      <input type="checkbox" id="lald-case__dropdown2" />
      <label for="lald-case__dropdown2" class="lald-case__dropdown-head">
        <div class="lald-case__dropdown-head-title">Источники</div>
        <div class="lald-case__dropdown-arrow">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.25 8.25L12.75 15.75L5.25 8.25"
              stroke="#3C4242"
              stroke-width="1.5"
              stroke-linecap="square"
            />
          </svg>
        </div>
      </label>
      <div class="lald-case__dropdown-body">
        <ol>
          <li>
            Клинические рекомендации. Другие нарушения накопления липидов
            (Дефицит лизосомой кислой липазы) ID: 354_2. 2023.
            <a
              href="https://cr.minzdrav.gov.ru/view-cr/354_2"
              target="_blank"
              style="text-decoration: underline; overflow-wrap: anywhere"
              >https://cr.minzdrav.gov.ru/view-cr/354_2</a
            >
            (дата обращения: 23.10.2025)
          </li>
          <li>
            Приказ Министерства здравоохранения Российской Федерации от
            14.04.2025 № 211н Об утверждении порядка прохождения
            несовершеннолетними профилактических медицинских осмотров, учетной
            формы № 030-ПО/у Карта профилактического медицинского осмотра
            несовершеннолетнего, порядка ее ведения, а также формы отраслевого
            статистического наблюдения № 030-ПО/о Сведения о профилактических
            медицинских осмотрах несовершеннолетних, порядка ее заполнения
            (Зарегистрирован 22.05.2025 № 82300)
            <a
              href="http://publication.pravo.gov.ru/document/0001202505230032"
              target="_blank"
              style="text-decoration: underline; overflow-wrap: anywhere"
              >http://publication.pravo.gov.ru/document/0001202505230032</a
            >
              (дата обращения: 23.10.2025)
          </li>
          <li>
            Hamilton J, Jones I, Srivastava R, Galloway P. A new method for the
            measurement of lysosomal acid lipase in dried blood spots using the
            inhibitor Lalistat 2. Clin Chim Acta. 2012;413(15-16):1207-1210.
          </li>
          <li>
            Lukacs Z, Barr M, Hamilton J. Best practice in the measurement and
            interpretation of lysosomal acid lipase in dried blood spots using
            the inhibitor Lalistat 2. Clin Chim Acta. 2017 Aug;471:201-205.
          </li>
          <li>
            Tylki-Szymańska A, Jurecka A. Lysosomal acid lipase deficiency:
            wolman disease and cholesteryl ester storage disease. Pril (Makedon
            Akad Nauk Umet Odd Med Nauki). 2014;35(1):99-106.
          </li>
          <li>
            Hoffman EP, Barr ML, Giovanni MA, Murray MF. Lysosomal Acid Lipase
            Deficiency. 2015 Jul 30 [updated 2016 Sep 1]. In: Adam MP, Feldman
            J, Mirzaa GM, Pagon RA, Wallace SE, Amemiya A, editors. GeneReviews®
            [Internet]. Seattle (WA): University of Washington, Seattle;
            1993–2025.
          </li>
          <li>
            Bernstein DL, Hülkova H, Bialer MG, Desnick RJ. Cholesteryl ester
            storage disease: review of the findings in 135 reported patients
            with an underdiagnosed disease. J Hepatol. 2013;58(6):1230-1243.
          </li>
          <li>
            Decarlis S, Agostoni C, Ferrante F, Scarlino S, Riva E, Giovannini
            M. Combined hyperlipidaemia as a presenting sign of cholesteryl
            ester storage disease. J Inherit Metab Dis. 2009;32 Suppl 1:S11-S13.
          </li>
          <li>
            Friedrich DA. Specialty Corner: Lysosomal Acid Lipase Deficiency
            (LAL-D). National Lipid Association.
            <a
              href="https://www.lipid.org/node/1772"
              target="_blank"
              style="text-decoration: underline; overflow-wrap: anywhere"
              >https://www.lipid.org/node/1772</a
            >
            (дата обращения: 23.10.2025)
          </li>
          <li>
            Клинические рекомендации. Нарушения липидного обмена. ID: 752_1.
            2023.
            <a
              href="https://cr.minzdrav.gov.ru/view-cr/752_1"
              target="_blank"
              style="text-decoration: underline; overflow-wrap: anywhere"
              >https://cr.minzdrav.gov.ru/view-cr/752_1</a
            >
            (дата обращения: 27.10.2025)
          </li>
          <li>
            Клинические рекомендации. Неалкогольная жировая болезнь печени. ID:
            748_2. 2024.
            <a
              href="https://cr.minzdrav.gov.ru/view-cr/748_2"
              target="_blank"
              style="text-decoration: underline; overflow-wrap: anywhere"
              >https://cr.minzdrav.gov.ru/view-cr/748_2</a
            >
              (дата обращения: 27.10.2025)
          </li>
          <li>
            Padda IS, Fabian D, Johal GS. Familial Combined Hyperlipidemia.
            StatPearls. Treasure Island (FL): StatPearls Publishing; 2025.
            <a
              href="https://www.ncbi.nlm.nih.gov/books/NBK592399/"
              target="_blank"
              style="text-decoration: underline; overflow-wrap: anywhere"
              >https://www.ncbi.nlm.nih.gov/books/NBK592399/</a
            >
            (дата обращения: 27.11.2025)
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Step1",
  props: {
    variant: [String, Number],
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/laldICC.scss";

.lald-case {
  &__block {
    &-body {
      &-row {
        display: grid;
        grid-template-columns: 390px 1fr;
        gap: 40px;

        @media screen and (max-width: 1219px) {
          grid-template-columns: 1fr;
        }

        @media screen and (max-width: 767px) {
          grid-template-columns: 1fr;
        }
      }

      &-content {
        &-status {
          gap: 12px;
          margin-bottom: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-family: "Roboto Slab", sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 24px;
          line-height: 32px;
        }

        &-buttons {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 16px;
          @media screen and (max-width: 767px) {
            flex-direction: column;
          }
        }
      }
    }
  }

  &__diagnostic {
    &-title {
      margin-top: 60px;
      padding-bottom: 16px;
      margin-bottom: 32px;
      border-bottom: 1px solid #d4cbcf;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 32px;
      line-height: 42px;
      color: #4c4c4c;

      @media screen and (max-width: 767px) {
        margin-top: 40px;
        font-size: 23px;
        line-height: 29px;
      }
    }

    &-subtitle {
      margin-bottom: 12px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 32px;
      color: #5c539e;

      @media screen and (max-width: 767px) {
        font-size: 20px;
        line-height: 24px;
      }
    }

    & img {
      max-width: 100%;
    }
  }

  &__materials {
    &-title {
      margin-top: 60px;
      padding-bottom: 16px;
      margin-bottom: 32px;
      border-bottom: 1px solid #d4cbcf;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 32px;
      line-height: 42px;
      color: #4c4c4c;

      @media screen and (max-width: 767px) {
        margin-top: 40px;
        font-size: 23px;
        line-height: 29px;
      }
    }

    &-row {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 32px;

      @media screen and (max-width: 1219px) {
        grid-template-columns: 1fr 1fr;
      }

      @media screen and (max-width: 767px) {
        grid-template-columns: 1fr;
      }
    }

    &-item {
      height: 100%;
      display: flex;
      flex-direction: column;
      &-img {
        margin-bottom: 20px;
        overflow: hidden;
        border-radius: 30px;

        & img {
          width: 100%;
        }
      }

      &-title {
        margin-bottom: 16px;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 26px;
        color: #4c4c4c;
      }

      &-button {
        margin-top: auto;
        background-color: #5c539e;
        color: #fff;

        @media screen and (max-width: 767px) {
          width: 100%;
        }

        &:hover {
          opacity: 0.7;
        }
      }
    }
  }

  &__dropdown {
    & input {
      display: none;

      &:checked {
        & ~ .lald-case__dropdown-head {
          & .lald-case__dropdown {
            &-arrow {
              transform: rotate(-180deg);
            }
          }
        }

        & ~ .lald-case__dropdown-body {
          display: block;
          padding: 32px 0;
        }
      }
    }

    &-head {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 16px;
      border-bottom: 1px solid #d2d2d2;
      cursor: pointer;

      &-title {
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 23px;
        line-height: 29px;
        color: #3c4242;
      }
    }

    &-arrow {
      margin-left: auto;
      transition: 0.3s;
    }

    &-body {
      display: none;
      border-bottom: 1px solid #d2d2d2;
    }
  }
}
</style>